export const printerTypes = {
    'INKJET': 'InkJet',
    'MONO_LASER': 'Mono Laser',
    'COLOUR_LASER': 'Colour Laser'
}